export default __webpack_public_path__ + "static/media/favicon.0c7b1fc2.png";